import { connect } from 'react-redux';

import { DispatchReduxAction } from '../../../store';
import { toggle } from '../../../store/popups/print';
import { IPrintButtonProps, PrintButton } from './index';

type TDispatchProps = Pick<IPrintButtonProps, 'openPrintModal'>;
type TOwnProps = Pick<IPrintButtonProps, 'className'>;

function mapDispatchToProps(dispatch: DispatchReduxAction): TDispatchProps {
  return {
    openPrintModal: () => dispatch(toggle(true)),
  };
}

export const PrintButtonContainer = connect<{}, TDispatchProps, TOwnProps>(() => ({}), mapDispatchToProps)(PrintButton);
